import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/styles';
import { Button, Link } from '@material-ui/core';
import { useFirebase } from 'components/Firebase/context';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center'
  },
  btn: {
    color: '#fff',
    maxWidth: 416,
    '&:hover': {
      textDecoration: 'none'
    }
  }
}));

const DownloadGuideButton = ({ storagePath, type }) => {
  const [downloadUrl, setDownloadUrl] = useState(null);
  const firebase = useFirebase();
  const classes = useStyles({})
;

  useEffect(() => {
    firebase.getFileDownloadUrl(storagePath).then(url => setDownloadUrl(url));
  });
  return (
    <div className={classes.root}>
      {downloadUrl && (
        <Button
          href={downloadUrl}
          target="_blank"
          className={classes.btn}
          variant="contained"
          component={Link}
          color="primary"
          fullWidth
        >
          download {type} guide
        </Button>
      )}
    </div>
  );
};

export default DownloadGuideButton;
